import React from 'react';
import { createPortal } from 'react-dom';
import { TagIcon, ChevronDownIcon } from '../icons';
import './TagsDropdown.css';

/**
 * TagsDropdown Component
 * Batch tag management with add/remove sections
 */
const TagsDropdown = ({
  isActive,
  onToggle,
  onAddTag,
  onRemoveTag,
  onClearTags,
  tagAnalysis,
  availableTags,
  tasks,
  menuStyle,
  buttonRef,
}) => {
  return (
    <div className="bulk-actions-toolbar__dropdown-container">
      <button
        ref={buttonRef}
        className={`bulk-actions-toolbar__btn ${isActive ? 'bulk-actions-toolbar__btn--active' : ''}`}
        onClick={(e) => onToggle('tags', e.currentTarget)}
        title="Manage tags"
      >
        <TagIcon />
        <span>Tags</span>
        <ChevronDownIcon />
      </button>
      {isActive && createPortal(
        <div className="bulk-actions-toolbar__menu bulk-actions-toolbar__menu--tags" style={menuStyle}>
          {/* Add Tag Section */}
          <div className="bulk-actions-toolbar__tags-section">
            <div className="bulk-actions-toolbar__tags-section-header">
              <span className="bulk-actions-toolbar__tags-section-title">Add Tag</span>
            </div>
            {tagAnalysis.addableTags.length > 0 ? (
              tagAnalysis.addableTags.map(tag => (
                <button
                  key={tag.id || tag.name}
                  className="bulk-actions-toolbar__menu-item"
                  onClick={() => onAddTag(tag.name)}
                >
                  <span className="bulk-actions-toolbar__tag-dot" style={{ background: tag.color || '#6b7280' }} />
                  <span>{tag.name}</span>
                  {tagAnalysis.tagCounts.get(tag.name) > 0 && (
                    <span className="bulk-actions-toolbar__tag-partial">
                      {tagAnalysis.tagCounts.get(tag.name)}/{tagAnalysis.totalSelected}
                    </span>
                  )}
                </button>
              ))
            ) : (
              <div className="bulk-actions-toolbar__tags-empty">
                {availableTags.length === 0 ? 'No tags available' : 'All tags applied'}
              </div>
            )}
          </div>

          {/* Remove Tag Section */}
          {tagAnalysis.removableTags.length > 0 && (
            <div className="bulk-actions-toolbar__tags-section bulk-actions-toolbar__tags-section--remove">
              <div className="bulk-actions-toolbar__tags-section-header">
                <span className="bulk-actions-toolbar__tags-section-title">Remove Tag</span>
              </div>
              {tagAnalysis.removableTags.map(tag => (
                <button
                  key={tag.id || tag.name}
                  className="bulk-actions-toolbar__menu-item bulk-actions-toolbar__menu-item--remove"
                  onClick={() => onRemoveTag(tag.name)}
                >
                  <span className="bulk-actions-toolbar__tag-dot" style={{ background: tag.color || '#6b7280' }} />
                  <span>{tag.name}</span>
                  <span className="bulk-actions-toolbar__tag-count">
                    {tag.isOnAll ? 'all' : `${tag.count}/${tagAnalysis.totalSelected}`}
                  </span>
                </button>
              ))}
            </div>
          )}

          {/* Clear All Tags */}
          {tagAnalysis.tasksWithTags > 0 && (
            <div className="bulk-actions-toolbar__tags-section bulk-actions-toolbar__tags-section--clear">
              <button
                className="bulk-actions-toolbar__menu-item bulk-actions-toolbar__menu-item--danger"
                onClick={() => onClearTags(tasks)}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
                <span>Clear all tags</span>
                <span className="bulk-actions-toolbar__tag-count">
                  {tagAnalysis.tasksWithTags} mission{tagAnalysis.tasksWithTags !== 1 ? 's' : ''}
                </span>
              </button>
            </div>
          )}
        </div>,
        document.body
      )}
    </div>
  );
};

export default TagsDropdown;
